export default __webpack_public_path__ + "static/LOGO-COLECHALLENGE-6c59e5faa2178ef92935c9de20c1062e.png";